import { createFileRoute } from "@tanstack/react-router";
import StormDamage from "@/pages/StormDamage";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/storm-damage")({
  head: () =>
    seo({
      title: "Storm Damage Roof & Siding Repair in Minnesota",
      description:
        "Hail, wind, and storm damage restoration for Twin Cities homes. Insurance claim help and fast emergency tarping. Call (612) 298-9865.",
      path: "/storm-damage",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Storm Damage", path: "/storm-damage" },
      ]),
    }),
  component: StormDamage,
});
